import React from 'react';
import { useIntl } from 'react-intl';
import { Footer as ClarikitFooter } from '@clariness/clarikit-react';
import { ExternalLinks } from 'global/externalLinks';

export const Footer: React.FC = () => {
  const intl = useIntl();

  return (
    <ClarikitFooter
      variant="investigatorService"
      viewport="responsive"
      style={{ marginTop: 'auto' }}
      copyright={intl.formatMessage(
        {
          id: 'is.footer.text',
          defaultMessage:
            'Copyright CLARINESS © 2006-{currentYear}. All rights reserved.',
        },
        { currentYear: new Date().getFullYear() }
      )}
      legalLinks={[
        {
          id: 'privacy-policy',
          label: intl.formatMessage({
            id: 'is.footer.link.privacy_policy',
            defaultMessage: 'Privacy policy',
          }),
          url: ExternalLinks.PRIVACY_POLICY,
          external: true,
        },
        {
          id: 'imprint',
          label: intl.formatMessage({
            id: 'is.footer.link.imprint',
            defaultMessage: 'Imprint',
          }),
          url: ExternalLinks.IMPRINT,
          external: true,
        },
        {
          id: 'terms-of-service',
          label: intl.formatMessage({
            id: 'is.footer.link.terms_of_service',
            defaultMessage: 'Terms of Service',
          }),
          url: ExternalLinks.TERMS_OF_USE,
          external: true,
        },
      ]}
    />
  );
};
